import type React from 'react';

import { type ActiveStates, getStateColor } from './InteractiveMap';
import State, { type StateType } from './State';
import { statePaths } from './stateInfo';
import type { InteractiveMapStateColorScheme } from './styleConstants';

interface StateGroupProps {
  states: ActiveStates[];
  stateType: StateType;
  hoveredState: string | undefined;
  setHoveredState: (state?: string) => void;
  colorScheme: InteractiveMapStateColorScheme;
}

const ActiveStatesGroup: React.FC<StateGroupProps> = ({
  states,
  stateType,
  hoveredState,
  setHoveredState,
  colorScheme,
}) => {
  return (
    <>
      {states.map(({ fields }) => {
        const { state, stateInfoUrl } = fields;
        return (
          <State
            key={state}
            state={state}
            type={stateType}
            link={{ href: stateInfoUrl, setHoveredState }}
            path={statePaths[state]}
            color={getStateColor(
              hoveredState,
              state,
              colorScheme,
              !stateInfoUrl
            )}
          />
        );
      })}
    </>
  );
};

export default ActiveStatesGroup;
